<template>
  <div>
    <div @click="openDialog()" class="pointer">
      <div>
        <span class="overline">Current search criteria:</span
        ><v-icon x-small color="primary" class="mx-1">mdi-pencil</v-icon
        ><span class="primary--text caption">edit</span>
      </div>
      <div class="caption ml-2">
        <ul>
          <li>
            <span class="font-weight-medium">Companies: </span>
            <span v-if="criteria.company == 'ALL'">All Companies</span>
            <span v-else>Alcon, B&amp;L, Coopervision, J&amp;J</span>
          </li>
          <li>
            <span class="font-weight-medium">Toric lens?</span>
            <span v-for="eye in ['od', 'os']" :key="eye" class="ml-2">
              {{ eye.toUpperCase() }}:
              <span v-if="wantToricString[eye] == 'Maybe'" class="blue--text"
                >Maybe</span
              >
              <v-icon v-else-if="wantToricString[eye] == 'No'" color="red"
                >mdi-alpha-x</v-icon
              >
              <v-icon v-else-if="wantToricString[eye] == 'Yes'" color="green"
                >mdi-check</v-icon
              >
            </span>
            <!-- OD:
            <v-icon :color="wantToric.od ? 'green' : 'red'"
              >mdi-{{ wantToric.od ? "check" : "alpha-x" }}</v-icon
            >
            OS:
            <v-icon :color="wantToric.os ? 'green' : 'red'"
              >mdi-{{ wantToric.os ? "check" : "alpha-x" }}</v-icon
            > -->
          </li>
          <!-- <li>
            Toric lens OS?
            <i>{{ wantToricString.os }}</i>
          </li> -->
          <li>
            <span class="font-weight-medium">Bifocal lenses?</span>
            <v-icon :color="wantBifocal ? 'green' : 'red'"
              >mdi-{{ wantBifocal ? "check" : "minus" }}</v-icon
            >
            <!-- <i>{{ wantBifocal ? "Yes" : "No" }}</i> -->
          </li>
          <li v-if="currentCriteria.cosmetic">
            <span class="font-weight-medium">Cosmetic lenses?</span>
            <v-icon :color="wantCosmetic ? 'green' : 'red'"
              >mdi-{{ wantCosmetic ? "check" : "mdi-alpha-x" }}</v-icon
            >
            <!-- <i>{{ wantCosmetic ? "Yes" : "No" }}</i> -->
          </li>
          <li v-if="currentCriteria.term">
            <span class="font-weight-medium">Lens name includes:</span>
            <span class="linkLike"> {{ currentCriteria.term }}</span>
          </li>
        </ul>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="400" scrollable>
      <!-- <template v-slot:activator="{ on, attrs }"> -->

      <!-- </template> -->

      <v-card class="mb-2" v-if="rxObjects">
        <div class="grey lighten-2 d-flex flex-row justify-space-between pa-4">
          <div class="text-h5">Change Search Criteria</div>
          <v-btn icon @click="dialog = false"
            ><v-icon color="primary">mdi-close</v-icon></v-btn
          >
        </div>

        <v-card-text class="py-6 px-2 px-sm-8">
          <div v-if="criteria.term">
            <v-text-field
              v-model="criteria.term"
              label="Lens name should include"
              dense
              outlined
              clearable
              hide-details="auto"
              @change="formChanged = true"
            ></v-text-field>
          </div>

          <!-- <div class="overline">Rxs</div> -->
          <v-card class="mt-2 mb-2" flat>
            <v-card-title
              class="d-flex flex-row justify-space-between cardTitle"
            >
              {{ rxObjects.od.vertex === 0 ? "CL power" : "Refraction" }}
              <rx-parser
                triggerTitle="edit"
                :editIcon="true"
                :textTrigger="true"
                :smallText="true"
                :icon="null"
                buttonColor="primary"
                :initialRxObjects="rxObjects"
                @rxChange="rxsEdited($event)"
              ></rx-parser>
              <!-- <v-btn color="primary" small icon
                ><v-icon color="primary" small>mdi-pencil</v-icon></v-btn
              > -->
            </v-card-title>
            <v-card-text class="pa-2 font16">
              <div class="" v-if="rxObjects.od">
                <span class="font-weight-medium mr-2">OD: </span>
                <span class="mr-4">{{ this.prettyString(rxObjects.od) }}</span>
                <span v-if="addString" class="caption"
                  >{{ addString }} add</span
                >
              </div>
              <div class="" v-if="rxObjects.os">
                <span class="font-weight-medium mr-2">OS: </span>
                <span class="mr-4">{{ this.prettyString(rxObjects.os) }}</span>
                <span v-if="addString" class="caption"
                  >{{ addString }} add</span
                >
              </div>
              <div v-if="addString" class="ml-10 caption">
                (<span v-if="rxObjects.os && rxObjects.os.dominant">OS</span
                ><span v-else>OD</span> dominant)
              </div>
            </v-card-text>
          </v-card>
          <v-card class="mb-2" flat>
            <v-card-title class="cardTitle">Companies</v-card-title>
            <v-card-text class="pa-2">
              <v-radio-group
                v-model="criteria.company"
                row
                dense
                hide-details="auto"
                class="mt-0"
                @change="formChanged = true"
              >
                <v-radio
                  label="Alcon, B&L, CooperVision, J&J"
                  value="MAIN"
                ></v-radio>
                <v-radio
                  label="All Companies (will take longer)"
                  value="ALL"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-2" flat>
            <v-card-title class="cardTitle">Toric lens?</v-card-title>
            <v-card-text class="pa-2">
              <v-radio-group
                label="OD: "
                v-model="criteria.toric.od"
                row
                dense
                hide-details="auto"
                class="mt-0"
                :disabled="!toricOK.od"
                @change="formChanged = true"
              >
                <v-radio label="Yes" :value="1"></v-radio>
                <v-radio label="No" :value="0"></v-radio>
                <v-radio label="Best VA" :value="null"></v-radio>
              </v-radio-group>
              <div v-if="!toricOK.od" class="caption text-center">
                (Not enough cylinder power)
              </div>
              <v-radio-group
                v-model="criteria.toric.os"
                label="OS: "
                row
                dense
                hide-details="auto"
                class="mt-0"
                :disabled="!toricOK.os"
                @change="formChanged = true"
              >
                <v-radio label="Yes" :value="1"></v-radio>
                <v-radio label="No" :value="0"></v-radio>
                <v-radio label="Best VA" :value="null"></v-radio>
              </v-radio-group>
              <div v-if="!toricOK.os" class="caption">
                (Not enough cylinder power)
              </div>
            </v-card-text>
          </v-card>

          <div class="my-6">
            <v-checkbox
              v-model="criteria.bifocal"
              label="I'm looking for bifocals"
              dense
              hide-details="auto"
              :true-value="1"
              @change="formChanged = true"
            ></v-checkbox>
            <v-fade-transition>
              <div
                class="ml-6 my-2 d-flex flex-row align-start"
                v-if="criteria.bifocal && !addString"
              >
                <div class="caption red--text">
                  Be sure to edit your Rx to include an add power.
                </div>
              </div>
            </v-fade-transition>
            <v-checkbox
              v-model="criteria.cosmetic"
              label="I'm looking for cosmetic lenses"
              dense
              hide-details="auto"
              :true-value="1"
              @change="formChanged = true"
            ></v-checkbox>
            <div class="my-3" style="height: 50px">
              <v-fade-transition>
                <v-alert
                  v-if="criteria.bifocal && criteria.cosmetic"
                  type="warning"
                  dense
                  class="my-0 py-0"
                >
                  Bifocal AND cosmetic? You Crazy.
                </v-alert>
              </v-fade-transition>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" text @click="dialog = false" outlined> Cancel </v-btn>
          <v-btn color="primary" @click="doSearch()" :disabled="!canSearch">
            Search
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RxMethods from "@/assets/js/cls/RxMethods";

export default {
  name: "EditPowerCriteria",
  mixins: [RxMethods],
  components: {
    RxParser: () => import("@/components/clStuff/RxParser"),
  },
  props: {
    initialRxObjects: null,
    currentCriteria: null,
  },
  data: function () {
    return {
      rxObjects: null,
      dialog: false,
      dominantEye: "od",
      goToPage: "/cls/rx",
      formChanged: false,
      initialCriteria: null,

      criteria: {
        company: "MAIN",
        toric: { od: null, os: null },
        bifocal: 0,
        cosmetic: 0,
        term: null,
      },
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.initialCriteria = this.criteriaHash;
    },
    doSearch() {
      // let criteriaHash = this.criteriaHash;
      // this.dialog = false;
      // console.log(criteriaHash);
      // let paramString = this.termQuery + "#" + this.criteriaHash;
      this.$router.push({ path: `${this.goToPage}` + this.criteriaHash });
    },
    getBool(val) {
      // to get 1,0, or null
      let rtn = null;
      if (val === 1 || val === "1") rtn = 1;
      if (val === 0 || val === "0") rtn = 0;
      // console.log(val, rtn);
      return rtn;
    },
    rxsEdited(rxs) {
      this.rxObjects = rxs;
      let dom = "od";
      if (rxs.os?.dominant) dom = "os";
      this.dominantEye = dom;
      this.formChanged = 1;
    },
  },
  computed: {
    criteriaHash() {
      // console.log("criteriaHash");
      let arr = [];
      let c = this.criteria;
      let rxs = JSON.parse(JSON.stringify(this.rxObjects)); // bad way to clone..?
      let addStr = this.addString;
      let addNum = addStr ? parseFloat(addStr) : 0;

      if (this.toricOK?.od && c.toric?.od != null)
        arr.push("toricOD=" + (c.toric.od === 0 ? "0" : "1"));
      if (this.toricOK?.os && c.toric?.os != null)
        arr.push("toricOS=" + (c.toric.os === 0 ? "0" : "1"));
      if (c.bifocal) {
        arr.push("bifocal=1");

        if (rxs?.od) {
          rxs.od.add = addNum;
          if (this.dominantEye == "od") rxs.od.dominant = 1;
        }
        if (rxs?.os) {
          rxs.os.add = addNum;
          if (this.dominantEye == "os") rxs.os.dominant = 1;
        }
      } else {
        arr.push("bifocal=0");
      }

      if (rxs?.od?.vertex) arr.push("vertex=" + rxs.od.vertex);
      if (c.cosmetic) arr.push("cosmetic=1");
      if (c.company == "MAIN") arr.push("company=MAIN");
      if (c.company == "ALL") arr.push("company=ALL");
      // if (this.isPlano(rxs["os"])) rxs["os"] = null;
      arr.push(this.rxHashOU(rxs));
      // if (this.isPlano(rxs.os)) delete arr.refractionOS;
      // if (this.isPlano(rxs.od)) delete arr.refractionOD;
      let hash = arr.join("&");

      return this.termQuery + "#" + hash;
    },
    termQuery: function () {
      return this.criteria.term
        ? "?q=" + encodeURIComponent(this.criteria.term)
        : "";
    },
    canSearch: function () {
      let criteria = this.criteria;
      // console.log("canSearch");
      if (criteria.bifocal && !this.addString) return false;
      // if (criteria.bifocal && !this.addString) return false;

      if (criteria.bifocal && criteria.cosmetic) return false; // don't allow both
      return this.criteriaHash != this.initialCriteria;
    },
    wantBifocal: function () {
      return this.currentCriteria?.bifocal;
    },
    wantCosmetic: function () {
      return this.currentCriteria?.cosmetic;
    },
    addString: function () {
      let rtn = null;
      if (this.rxObjects?.od?.add) {
        rtn = this.prettyAdd(this.rxObjects.od);
      } else if (this.rxObjects?.os?.add) {
        rtn = this.prettyAdd(this.rxObjects.os);
      }
      return rtn;
    },
    // dominantEye: function () {
    //   let dom = "od";
    //   if (this.rxObjects?.os?.add && this.rxObjects.os.dominant) dom = "os";
    //   return dom;
    // },
    // bifocalOK: function () {
    //   let rtn = true;
    //   if (this.wantBifocal) {
    //     if (!this.addString || !this.newAdd)
    //   }
    // },
    cylAmt: function () {
      let rtn = { od: null, os: null };
      rtn.od = this.cylP(this.rxObjects?.od);
      rtn.os = this.cylP(this.rxObjects?.os);
      return rtn;
    },
    toricOK: function () {
      let rtn = { od: true, os: true };
      if (!this.rxObjects?.od || this.cylAmt?.od < 0.5) rtn.od = false;
      if (!this.rxObjects?.os || this.cylAmt?.os < 0.5) rtn.os = false;
      return rtn;
    },
    wantToric: function () {
      let rtn = { od: null, os: null };
      rtn.od = this.getBool(this.currentCriteria?.toric?.od);
      rtn.os = this.getBool(this.currentCriteria?.toric?.os);
      return rtn;
    },
    wantToricString: function () {
      let rtn = { od: "Maybe", os: "Maybe" };
      let w = this.wantToric;
      let ok = this.toricOK;
      for (const eye of ["od", "os"]) {
        let cyl = this.cylAmt[eye];
        if (w[eye] === 1 && ok[eye]) rtn[eye] = "Yes";
        if (w[eye] === 0) rtn[eye] = "No";
        if (!ok[eye]) rtn[eye] = "No";
        if (ok[eye] && w[eye] === null && cyl >= 1) rtn[eye] = "Yes";
      }

      return rtn;
    },
  },
  watch: {},
  mounted: function () {
    // console.log("mounted");
    // let rxs = this.rxObjects;
    // I hate cloning this way ..
    if (this.initialRxObjects)
      this.rxObjects = JSON.parse(JSON.stringify(this.initialRxObjects));
    let current = this.currentCriteria;
    if (!current) return;
    // if (current.add) this.addString = "+" + parseFloat(current.add).toFixed(2);
    this.criteria.bifocal = parseInt(current?.bifocal);
    if (current.dominantOD) this.dominantEye = "od";
    if (current.dominantOS) this.dominantEye = "os";
    this.criteria.company = current.company == "ALL" ? "ALL" : "MAIN";
    this.criteria.cosmetic = parseInt(current.cosmetic);
    this.criteria.toric.od = this.getBool(current.toric?.od);
    this.criteria.toric.os = this.getBool(current.toric?.os);
    this.criteria.term = current.term;

    // if (this.addString) this.newAdd = parseInt(this.addString);
  },
};
</script>

<style scoped>
.cardTitle {
  background-color: #def0ff;
  padding: 4px 8px;
}
.font16 {
  font-size: 16px;
}
</style>
